import React, { useState, useRef, useEffect } from "react";
import {
  UilEllipsisV,
  UilEye,
  UilEyeSlash,
  UilTrashAlt,
  UilBox,
  UilInfoCircle,
  UilSpinnerAlt,
} from "@iconscout/react-unicons";
import { useNavigate } from "react-router-dom";


export function ActionMenu({ data }) {
  const navigate = useNavigate()


  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const close = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, []);
  const actions = () => [
    {
      label: "View Details",
      icon: <UilInfoCircle />,
      color: "text-gray-700",
      statuses: ["pending", "live", "unpublished", "draft", "rejected"],
      onClick: (data) => navigate(`/movie-box/${data?.id}`)
    },
    {
      label: "Unpublish",
      icon: <UilEyeSlash />,
      color: "text-gray-700",
      statuses: ["live"]
    },
    {
      label: "Move to Archive",
      icon: <UilBox />,
      color: "text-red-600",
      statuses: ["live", "unpublished"]
    },
    {
      label: "Continue",
      icon: <UilSpinnerAlt />,
      color: "text-gray-700",
      statuses: ["draft"],
      onClick: (data) => navigate(`/movie-box/add-movie/movie-details?id=${data?.id}`)
    },
    {
      label: "Delete",
      icon: <UilTrashAlt />,
      color: "text-red-600",
      statuses: ["draft", "archived", "rejected"]
    },
    {
      label: "Go Live",
      icon: <UilEye />,
      color: "text-gray-700",
      statuses: ["unpublished"]
    },
    {
      label: "Restore",
      icon: <UilInfoCircle />,
      color: "text-gray-700",
      statuses: ["archived"]
    },
  ];

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen((prev) => !prev)}
        className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-200"
      >
        <UilEllipsisV size={18} className="text-gray-500" />
      </button>
      {open && (
        <div className="absolute right-0 z-20 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-md">
          <ul className="text-sm text-gray-700 py-1">
            {actions().filter(action => action?.statuses?.includes(data?.status?.toLowerCase())).map((action, index) => (
              <li
                key={index}
                onClick={() => {

                  setOpen(false);
                  action?.onClick?.(data)
                }}
                className={`flex items-center px-4 py-2 space-x-2 cursor-pointer hover:bg-gray-100 ${action.color}`}
              >
                {action.icon}
                <span>{action.label}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
